var menu_versions = require('./menu_versions');
var currentVersion = parseInt(localStorage.getItem("app_version"));
export default {
  items: currentVersion == 13 ? menu_versions.v013 : menu_versions.v020
}